export interface InternationalTopUpSelectedCarrier {
    id: string;
    name: string;
}
